export default __webpack_public_path__ + "static/media/no_seen_icon.2dceaac6.svg";